import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal'; // Import Modal from React-Bootstrap
import { GoogleLogin } from '@react-oauth/google';
import useLogin, { useGoogleLogin } from '../utils/login';
import { useAuthStore } from '../store/auth';

const LoginForm = ({ onClose, onForgotPassword }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState(''); // State to store the error message
    const [errorModal, setErrorModal] = useState(false); // State to control error modal visibility
    const isLoggedIn = useAuthStore((state) => state.isLoggedIn);

    // Shared across pages, not local state — other pages (e.g. the
    // calculator's entry flow) wait for this to clear before showing
    // their own follow-up modal, instead of both appearing at once.
    // The "You are logged in" modal itself is rendered in Navbar (keyed
    // off this same flag), not here, so it survives this component
    // unmounting on successful login — see handleLogin below.
    const setShowLogInWelcome = useAuthStore((state) => state.setShowLoginWelcomeModal);
    const setLoginWelcomeVariant = useAuthStore((state) => state.setLoginWelcomeVariant);

    // not sure what this useEffect is for and how LoginForm can be enacted if user is already logged in
    // useEffect(() => {
    //     if (isLoggedIn()) {
    //         onClose(); // Close the modal if already logged in
    //     }
    // }, [isLoggedIn, onClose]);

    const resetForm = () => {
        setUsername('');
        setPassword('');
        setErrorMessage(''); // Reset the error message
    };

    const { login } = useLogin();
    const { googleLogin } = useGoogleLogin();

    const handleLoginSuccess = (variant = 'standard') => {
        // Close this modal (and unmount the form/password field)
        // immediately on success — don't wait for the user to dismiss
        // a follow-up "You are logged in" modal first. Chrome's
        // save-password prompt for non-navigating (SPA) logins relies
        // on seeing the page actually react to the successful submit;
        // leaving the password field sitting in the DOM behind a
        // stacked confirmation modal for an indefinite period gives it
        // no such signal. The welcome modal itself now lives in
        // Navbar (keyed off the same global store flag) so it still
        // shows after this component unmounts. Also don't clear
        // username/password here — briefly clearing them right before
        // unmount was the other thing suppressing the save prompt.
        setLoginWelcomeVariant(variant);
        setShowLogInWelcome(true);
        // Only passed when rendered as a modal (Navbar) — the
        // standalone /login page route doesn't have anything to
        // close, and the "You are logged in" modal above (rendered
        // in Navbar, keyed off the same store flag) already gives
        // that route its own success feedback.
        onClose?.();
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        const { error } = await login(username, password);

        if (error) {
            if (error.username) {
                setErrorMessage(error.username);
            } else if (error.password) {
                setErrorMessage(error.password);
            } else if (error.detail) {
                setErrorMessage(error.detail);
            }
            else {
                setErrorModal(true);
            }
        } else {
            handleLoginSuccess();
        }
    };

    const handleGoogleSuccess = async (credentialResponse) => {
        const { data, error } = await googleLogin(credentialResponse.credential);
        if (error) {
            setErrorMessage(error.detail);
        } else {
            handleLoginSuccess(data?.is_new_user ? 'new_google_account' : 'standard');
        }
    };

    // Close the error modal
    const handleCloseErrorModal = () => {
        resetForm();
        setErrorModal(false);
    };

    return (
        <>
            <section>
                <Form onSubmit={handleLogin}>
                    <Form.Group>
                        <Form.Label htmlFor="username" className="small">Username:</Form.Label>
                        <Form.Control 
                            type="text"
                            id="username"
                            name="username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            autoComplete="username"
                            placeholder="Username"
                        />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label htmlFor="password" className="small">Password:</Form.Label>
                        <Form.Control
                            type="password"
                            id="password"
                            name="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            autoComplete="current-password"
                            placeholder="Password"                
                        />
                    </Form.Group>
                    {/* Display error message */}
                    {errorMessage && (
                        <div style={{ color: 'red', marginTop: '10px' }}>
                            {errorMessage}
                        </div>
                    )}
                    <br />
                    <Button variant="success" type="submit">
                        Log In
                    </Button>
                    {onForgotPassword && (
                        <Button variant="outline-secondary" size="sm" className="ms-2" onClick={onForgotPassword}>
                            Reset Password
                        </Button>
                    )}
                </Form>
                <div style={{ marginTop: '15px' }}>
                    <GoogleLogin
                        onSuccess={handleGoogleSuccess}
                        onError={() => setErrorMessage('Google sign-in failed. Please try again.')}
                    />
                </div>
            </section>

            {/* Error modal to show in case of unhandled error */}
            <Modal show={errorModal} onHide={handleCloseErrorModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Error</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Something went wrong. Contact administrator if issue persists.
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseErrorModal}>
                        OK
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default LoginForm;

{/* <p>
    You can now save and retrieve plans under 
    <span 
    className="btn btn-success" 
    style={{ 
        cursor: 'default', 
        pointerEvents: 'none', 
        marginLeft: '5px', 
        marginRight: '5px', 
        marginBottom: '4px',
        padding: '2px 6px',  // Reduces the padding to make it smaller
        fontSize: 'inherit'   // Keeps the text size the same as the surrounding text
    }}>
    Manage Plan
    </span> 
    in the Simulation Calculator.
</p> */}